import { render, staticRenderFns } from "./ruleDetaile.vue?vue&type=template&id=7122fc9d&scoped=true&"
import script from "./ruleDetaile.vue?vue&type=script&lang=js&"
export * from "./ruleDetaile.vue?vue&type=script&lang=js&"
import style0 from "./ruleDetaile.vue?vue&type=style&index=0&id=7122fc9d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7122fc9d",
  null
  
)

export default component.exports